<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('withdraw.with_record') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <section class="km-section">
          <div v-if="list.length === 0" class="km-empty">
            <div class="km-empty__emoji">📤</div>
            <h3>{{ $t('withdraw.empty_data') }}</h3>
            <p>Your withdrawal history will appear here.</p>
          </div>
          <article v-else v-for="(v, key) in list" :key="key" class="kwr">
            <div class="kwr__head">
              <span class="kwr__pill" :class="statusClass(v.status)">{{ v.status_text }}</span>
              <span class="kwr__amount">- {{ formatMoney(v.money) }}</span>
            </div>
            <div class="kwr__desc">{{ v.desc }}</div>
            <div class="kwr__meta">
              <div><span>{{ $t('withdraw.submit_time') }}</span><strong>{{ v.create_time }}</strong></div>
              <div><span>{{ $t('withdraw.check_time') }}</span><strong>{{ v.update_time }}</strong></div>
            </div>
          </article>
        </section>
      </van-pull-refresh>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { isLoading: false, list: [] }; },
  methods: {
    back() { return window.history.back(); },
    formatMoney(v) {
      const n = Number(v);
      if (isNaN(n)) return String(v || '0');
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    statusClass(s) {
      if (s === 2 || s === 4) return 'kwr__pill--ok';
      if (s === 3) return 'kwr__pill--fail';
      return 'kwr__pill--pending';
    },
    onRefresh() {
      setTimeout(() => { this.$toast(this.$t("reservation.refresh")); this.isLoading = false; this.getUserWithdrawList(); }, 500);
    },
    getUserWithdrawList() {
      this.$http({ method: 'get', url: 'user_get_withdraw_list' }).then(res => {
        if (res.code === 200) this.list = res.data;
        else if (res.code === 401) this.$toast(res.msg);
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserWithdrawList();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";

.kwr {
  background: linear-gradient(180deg, #fff 0%, #fff6fa 100%);
  border-radius: 16px;
  border: 1px solid rgba(255,77,141,.12);
  box-shadow: 0 6px 18px rgba(255,77,141,.08), inset 0 1px 0 rgba(255,255,255,.9);
  padding: 16px;
  margin-bottom: 12px;
}
.kwr__head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 10px; }
.kwr__pill {
  font-size: 11px; font-weight: 800; padding: 4px 10px; border-radius: 999px;
  text-transform: uppercase; letter-spacing: .05em;
}
.kwr__pill--ok { background: rgba(16,185,129,.15); color: #059669; }
.kwr__pill--fail { background: rgba(239,68,68,.15); color: #dc2626; }
.kwr__pill--pending { background: rgba(251,191,36,.18); color: #b45309; }
.kwr__amount {
  font-size: 18px; font-weight: 800; letter-spacing: -.01em;
  background: linear-gradient(90deg, #ef4444, #dc2626);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.kwr__desc {
  font-size: 13px; color: #5a4a78; margin-bottom: 10px;
  padding-bottom: 10px; border-bottom: 1px solid rgba(255,77,141,.08);
  line-height: 1.5;
}
.kwr__meta { display: flex; flex-direction: column; gap: 4px; font-size: 12px; }
.kwr__meta > div { display: flex; justify-content: space-between; gap: 10px; }
.kwr__meta span { color: #8273a0; }
.kwr__meta strong { color: #2a1a3f; font-weight: 600; }

.km-empty { text-align: center; padding: 60px 20px; color: #6b5c85; }
.km-empty__emoji { font-size: 50px; margin-bottom: 10px; }
.km-empty h3 { margin: 0 0 6px; font-size: 16px; color: #2a1a3f; }
.km-empty p { margin: 0; font-size: 13px; }

::v-deep .van-pull-refresh__head * { color: #6b5c85; font-size: 13px; }
::v-deep .van-empty { padding: 40px 0; }
</style>
